import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import PageLines from "../components/PageLines";
import ContactSection from "../components/ContactSection";
import Navbar from "../components/Navbar";
import CustomLoader from "../components/CustomLoader";
import { useWOW } from "../hooks/useWOW";
import useStickyNavbar from "../hooks/useStickyNavbar";
import "../assets/css/furniture-showcase.css";

function Furnitures() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Initialize WOW.js for scroll animations
  useWOW();
  useStickyNavbar();

  // State for modal
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Image data with titles
  const furnitureImages = [
    {
      src: "/img/xinchuan/xinchuan_kitchen.jpg",
      title: "Custom Kitchen Design",
      category: "Kitchen Cabinetry",
    },
    {
      src: "/img/xinchuan/xinchuan_living_room.jpg",
      title: "Living Room Furniture",
      category: "Interior Design",
    },
    {
      src: "/img/xinchuan/xinchuan_study_room.jpg",
      title: "Study Room Setup",
      category: "Home Office",
    },
    {
      src: "/img/xinchuan/xinchuan_office.jpg",
      title: "Office Interior Design",
      category: "Commercial Space",
    },
    {
      src: "/img/xinchuan/xinchuan_office_demo.jpg",
      title: "Office Demo Design",
      category: "Workspace",
    },
    {
      src: "/img/xinchuan/xinchuan_office_demo2.jpg",
      title: "Modern Office Layout",
      category: "Corporate Design",
    },
    {
      src: "/img/xinchuan/xinchuan_office_outlook.jpg",
      title: "Office Overview",
      category: "Space Planning",
    },
    {
      src: "/img/xinchuan/xinchuan_office_layout.jpeg",
      title: "Office Layout Design",
      category: "Architecture",
    },
    {
      src: "/img/xinchuan/xinchuan_design_home.jpg",
      title: "Home Design Concept",
      category: "Residential",
    },
    {
      src: "/img/xinchuan/main1.jpeg",
      title: "Main Showcase",
      category: "Portfolio",
    },
  ];

  const handleCardClick = (imageData) => {
    setSelectedImage(imageData);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="layout">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      {/* Navbar */}
      <Navbar />

      {/* Main Header Section */}
      <main
        className="main main-inner bg-furniture"
        style={{
          backgroundImage: "url('/img/xinchuan/xinchuan_office_demo.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <header className="main-header">
            <h1>Furniture Customization</h1>
          </header>
        </div>
        <PageLines />
      </main>

      <div className="content">
        {/* 3D Rotating Cards Animation Section */}
        <section id="furniture-showcase" className="section">
          <div className="container">
            <header className="section-header">
              <h2 className="section-title">
                Furniture <span className="text-primary">Showcase</span>
              </h2>
            </header>
            <div className="section-content">
              <div className="wrapper">
                <div className="inner" style={{ "--quantity": "10" }}>
                  {furnitureImages.map((image, index) => (
                    <div
                      key={index}
                      className="card"
                      style={{
                        "--index": index,
                      }}
                      onClick={() => handleCardClick(image)}
                    >
                      <div
                        className="img"
                        style={{ backgroundImage: `url('${image.src}')` }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Image Modal */}
        {isModalOpen && selectedImage && (
          <div className="image-modal-overlay" onClick={closeModal}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close-btn" onClick={closeModal}>
                ×
              </button>
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="modal-image"
              />
              <div className="modal-info">
                <h3>{selectedImage.title}</h3>
                <p>{selectedImage.category}</p>
              </div>
            </div>
          </div>
        )}

        {/* Contact Section */}
        <ContactSection />
        <Footer />
        {/* Lines */}
        <PageLines />
      </div>
    </div>
  );
}

export default Furnitures;
